import React from 'react';

interface SemanticSegmentationIconProps {
  style?: React.CSSProperties;
}

const SemanticSegmentationIcon: React.FC<SemanticSegmentationIconProps> = ({ style }) => {
  return (
    <svg style={style} viewBox="0 0 26 30">
      <title>Semantic Segmentation</title>
      <g clipPath="url(#clip0)">
        <path
          d="M0 15l3.249 1.275 3.249 2.475 6.492 3.75-2.727 2.175-3.768 1.575L0 22.5V15z"
          fill="#FD9D52"
        />
        <path d="M6.495 26.25l12.99-7.5.519 3.45-.519 4.05L12.99 30l-6.495-3.75z" fill="#943CFF" />
        <path d="M19.485 26.25v-15l3.249 1.275L25.98 15v7.5l-6.495 3.75z" fill="#DD45D3" />
        <path d="M25.98 15L12.99 7.5l2.727-2.175 3.768-1.575L25.98 7.5V15z" fill="#FD9D52" />
        <path d="M19.485 3.75l-12.99 7.5-.519-3.45.519-4.05L12.99 0l6.495 3.75z" fill="#943CFF" />
        <path d="M6.495 3.75v15L0 15V7.5l6.495-3.75z" fill="#DD45D3" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h25.98v30H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SemanticSegmentationIcon;
